import React from 'react';
import { Field, ErrorMessage, FieldArray, useFormikContext } from 'formik';
import { Box, Grid, TextField, IconButton, Button, Tooltip, Stack, Paper, Typography } from "@mui/material";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

export default function SkillsStep({ values }) {
    const { errors, touched } = useFormikContext();
    const fieldSx = { '& .MuiOutlinedInput-root': { borderRadius: '12px' } };

    return (
        <Box pt={2}>
            <FieldArray name="skills">
                {({ remove, push }) => (
                    <Stack spacing={2}>
                        {values.skills.map((skill, index) => (
                            <Paper key={index} variant="outlined" sx={{ p: 2, borderRadius: '16px' }}>
                                <Grid container spacing={2} alignItems="flex-start">
                                    <Grid item xs>
                                        <Field
                                            as={TextField}
                                            fullWidth
                                            label={`Skill #${index + 1}`}
                                            name={`skills[${index}].name`}
                                            helperText={
                                                <Box component="span" sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                    <span><ErrorMessage name={`skills[${index}].name`} /></span>
                                                    <Typography variant="caption" sx={{ ml: 'auto' }}>
                                                        {`${skill.name.length} / 50`}
                                                    </Typography>
                                                </Box>
                                            }
                                            error={touched.skills?.[index]?.name && Boolean(errors.skills?.[index]?.name)}
                                            sx={fieldSx}
                                            inputProps={{ maxLength: 50 }}
                                        />
                                    </Grid>
                                    <Grid item xs={4} sm={3}>
                                        <Field
                                            as={TextField}
                                            fullWidth
                                            label="Weight"
                                            type="number"
                                            name={`skills[${index}].weight`}
                                            helperText={<ErrorMessage name={`skills[${index}].weight`} />}
                                            error={touched.skills?.[index]?.weight && Boolean(errors.skills?.[index]?.weight)}
                                            sx={fieldSx}
                                        />
                                    </Grid>
                                    <Grid item xs="auto">
                                        <Tooltip title="Remove Skill">
                                            <IconButton sx={{mt: 1}} onClick={() => values.skills.length > 1 && remove(index)} disabled={values.skills.length <= 1}>
                                                <DeleteOutlineIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </Grid>
                                </Grid>
                            </Paper>
                        ))}
                        <Button startIcon={<AddCircleOutlineIcon />} onClick={() => push({ name: '', weight: 5 })} sx={{ alignSelf: 'flex-start' }}>
                            Add Skill
                        </Button>
                    </Stack>
                )}
            </FieldArray>
        </Box>
    );
}
